const isMobile = () => window.innerWidth <= 768;

export const TOUR_STEPS = {
  // Overview page main tour
  OVERVIEW: {
    MAIN: {
      OVERVIEW: {
        id: 'overview',
        title: 'hereIsTheOverview',
        text: 'hereYouWillFindAGeneralView',
        position: 'bottom',
      },
      BALANCES_SELECTION: {
        id: 'balances-selection',
        title: 'accountBalances',
        text: 'hereYouCanSeeYourBalanceInEach',
        position: 'bottom',
      },
      CONTACTS_SELECTION: {
        id: 'contacts',
        title: 'contacts',
        text: 'yourContactsAreNickyUsers',
        position: 'bottom',
      },
      TRANSACTIONS_SELECTION: {
        id: 'transactions-selection',
        title: 'transactions',
        text: 'hereTheTransactionsControlledByNicky',
        position: 'bottom',
      },
      TRANSACTIONS_BUTTON: {
        id: 'transactions-see-all-button',
        title: 'transactions',
        text: 'clickHereToSeeABreakdownOfAllYourTransactions',
        position: 'bottom',
      },
    },
    // Overview page section-specific tours
    SECTIONS: {
      BALANCE_SECTION: {
        CRYPTO: {
          id: 'crypto-balance',
          title: 'cryptoBalances',
          text: 'viewYourCryptocurrencyBalancesHere',
          position: 'bottom',
        },
        FIAT: {
          id: 'fiat-balance',
          title: 'fiatBalances',
          text: 'viewYourFiatCurrencyBalancesHere',
          position: 'bottom',
        },
      },
      ACTIVITY_SECTION: {
        RECENT: {
          id: 'recent-activity',
          title: 'recentActivity',
          text: 'yourLatestTransactionsAndActivities',
          position: 'bottom',
        },
        STATS: {
          id: 'activity-stats',
          title: 'activityStatistics',
          text: 'overviewOfYourTransactionPatterns',
          position: 'bottom',
        },
      },
    },
  },

  // Payment Request TRANSACTIONS pages tours
  TRANSACTIONS: {
    TRANSACTIONS_SELECTION: {
      id: 'transactions-selection',
      title: 'hereAreThePaymentReports',
      text: 'paymentReportsAreAmountTransferred',
      position: 'bottom',
    },
    TRANSACTIONS_BUTTON: {
      id: 'reports-tab-button',
      title: 'transactions',
      text: 'paymentReportsAreAmountTransferred',
      position: 'bottom',
    },
    PAYMENT_REQUESTS: {
      id: 'requests-tab-button',
      title: 'paymentRequests',
      text: 'paymentRequestsAreGenerated',
      position: 'bottom',
    },
    PAYMENT_REQUESTS_BUTTON: {
      id: 'payment-request-button',
      title: 'paymentRequests',
      text: 'thisIsWhereYouCreateAPaymentRequest',
      position: 'bottom',
    },
  },

  // Payment Report page tours

  PAYMENT_REPORT: {
    INFORMATION: {
      RECEIVED: {
        id: 'received',
        title: '',
        text: 'thisIsTheAmountChargedInItsOriginalCurrency',
        position: 'bottom',
      },
      PAID: {
        id: 'paid',
        title: '',
        text: 'pleaseMakeSureToUseTheChosenNetworkWhenMakingTheTransaction',
        position: 'bottom',
      },
      RATE: {
        id: 'rate',
        title: '',
        text: 'thisIsTheRateUsedToCalculateTheAmountToBePaid',
        position: 'bottom',
      },
      NEXT_BUTTON: {
        id: 'next-button',
        title: '',
        text: 'clickNextToContinueWithYourPayment',
        position: 'bottom',
      },
    },
    PAYMENT: {
      AMOUNT_RECEIVED: {
        id: 'amount-received',
        title: '',
        text: 'thisIsTheAmountChargedInItsOriginalCurrency',
        position: 'bottom',
      },
      AMOUNT_PAID: {
        id: 'amount-paid',
        title: '',
        text: 'amountThatYouWillPay',
        position: 'bottom',
      },
      PAYMENT_DEADLINE: {
        id: 'payment-deadline',
        title: '',
        text: 'youNeedToFinishPayingWithinThisTime',
        position: 'bottom',
      },
      CURRENT_RATE: {
        id: 'current-rate',
        title: '',
        text: 'rateUsedToCalculateAmount',
        position: 'bottom',
      },
      PAYMENT_ADDRESS: {
        id: 'payment-address',
        title: '',
        text: 'payToThisAddress',
        position: 'bottom',
      },
      CONFIRMATION_STEP: {
        id: 'confirmation-step',
        title: '',
        text: 'confirmYouHaveSent',
        position: 'bottom',
      },
    },
  },

  // Public Profile page tours
  PUBLIC_PROFILE: {
    PROFILE_CARD: {
      id: 'profile-card',
      title: 'profileInformation',
      text: 'hereYouCanSeeEverythingAboutYourNickyProfile',
      position: 'bottom',
    },
    PROFILE_ID: {
      id: 'profile-id',
      title: 'profileId',
      text: 'thatsYourShortIDThatsYourNickyID',
      position: 'bottom',
    },
    PROFILE_SHARE_BUTTON: {
      id: 'profile-share-button',
      title: 'shareProfile',
      text: 'hereYouAccessYourProfileLinkOrQRCodeToShare',
      position: 'bottom',
      additionalButtonConfig: {
        onBackFunction: () => {},
        onNextFunction: () => {
          clickOnButton('profile-share-button');
        },
      },
    },

    QR_CODE: {
      id: 'qr-code',
      title: 'qrCode',
      text: 'hereYouCanSeeTheQRCodeOfYourProfileToShareIt',
      position: 'bottom',
      additionalButtonConfig: {
        onBackFunction: () => {
          closeModal('share-modal', 'close-button');
        },
        onNextFunction: () => {},
      },
    },
    PROFILE_LINK_CONTAINER: {
      id: 'profile-link-container',
      title: 'profileLink',
      text: 'hereYouCanCopyYourProfileLink',
      position: 'bottom',
    },

    COPY_LINK: {
      id: 'copy-link',
      title: 'copyLink',
      text: 'toCopyYourProfileLinkJustClickHere',
      position: 'bottom',
    },

    CLOSE_SHARE_MODAL_BUTTON: {
      id: 'close-button',
      title: 'close',
      text: 'toCloseClickHere',
      position: 'bottom',
      additionalButtonConfig: {
        onBackFunction: () => {},
        onNextFunction: () => {
          closeModal('share-modal', 'close-button');
        },
      },
    },

    PAY_BUTTON: {
      id: 'pay-button',
      title: 'pay',
      text: 'clickHereToRegisterAPaymentIfYourWalletsAreConfigured',
      position: 'bottom',
      additionalButtonConfig: {
        onBackFunction: () => {
          reopenModal('profile-share-button');
        },
        onNextFunction: () => {},
      },
    },
    PAYMENT_METHODS_SECTION: {
      id: 'payment-methods-section',
      title: 'paymentMethods',
      text: 'hereYouCheckActiveAssetsForPayment',
      position: 'bottom',
    },
    PAYMENT_METHODS_SECTION_TITLE: {
      title: 'endOfProfileTour',
      text: 'thisIsTheEndOfProfileTour',
    },
  },

  // General settings page tours
  SETTINGS: {
    OVERVIEW: {
      WELCOME_MESSAGE: {
        title: 'welcomeToSettingsTabsTour',
        text: 'letUsShowYouAround',
        position: 'bottom',
      },
      GENERAL_TAB: {
        id: isMobile() ? 'general' : 'settings-tab-general',
        title: 'welcomeToTheAccountSection',
        text: 'welcomeToNickyTour',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => navigateToSection('general', 'settings-tab-general'),
        },
      },
      WALLETS_TAB: {
        id: isMobile() ? 'wallet-connection' : 'settings-tab-wallet-connections',
        title: 'welcomeToTheWalletsSection',
        text: 'hereYouCanAddOrCheckyourWalletServiceProviderConnections',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => navigateToSection('wallet-connection', 'settings-tab-wallet-connections'),
        },
      },
      KIT_TAB: {
        id: isMobile() ? 'starter-kit' : 'settings-tab-starter-kit',
        title: 'welcomeToTheStarterKitSection',
        text: 'hereYouWillFindExclusiveOffers',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => navigateToSection('starter-kit', 'settings-tab-starter-kit'),
        },
      },
      NICKYS_TAB: {
        id: isMobile() ? 'my-nicks' : 'settings-tab-my-nicks',
        title: 'welcomeToTheNicksSection',
        text: 'hereYouCanViewAllYourActiveNicks',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => navigateToSection('my-nicks', 'settings-tab-my-nicks'),
        },
      },
      PAYMENT_CONVERSATIONS_TAB: {
        id: isMobile() ? 'payment-conversions' : 'settings-tab-merchant-configuration',
        title: 'welcomeToThePaymentConversionsSection',
        text: 'nickyCanAutomaticallyConvertCryptoIntoCurrency',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => navigateToSection('payment-conversions', 'settings-tab-merchant-configuration'),
        },
      },
      BANK_WITHDRAWAL_TAB: {
        id: isMobile() ? 'bank-withdrawal' : 'settings-tab-bank-withdrawal',
        title: 'welcomeToTheBankWithdrawalsSection',
        text: 'nickyCanAutomaticallyWithdrawFundsIntoYourBankAccount',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => navigateToSection('bank-withdrawal', 'settings-tab-bank-withdrawal'),
        },
      },
      SECURITY_TAB: {
        id: isMobile() ? 'security' : 'settings-tab-security',
        title: 'welcomeToTheSecuritySection',
        text: 'inCaseYouHaveALocalAccount',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => navigateToSection('security', 'settings-tab-security'),
        },
      },
      API_TAB: {
        id: isMobile() ? 'api-key-management' : 'settings-tab-api-key-management',
        title: 'welcomeToTheApiSection',
        text: 'hereYouCanGenerateNewKeys',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => navigateToSection('api-key-management', 'settings-tab-api-key-management'),
        },
      },
      MORE_INFO: {
        id: 'settings-page-navigation',
        title: '',
        text: 'lookForTheBookIconForMoreInfo',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => {
            clickOnButton('settings-page-navigation');
          },
        },
      },
      END_OF_TOUR: {
        title: 'welcomeToTheBankEndOfTour',
        text: 'weHopeYouEnjoyUsingNicky!',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => {
            clickOnButton('settings-tab-general');
          },
        },
      },
    },
    GENERAL: {
      WELCOME_MESSAGE: {
        id: 'general-settings',
        title: 'welcomeToTheAccountSection',
        text: 'hereYouConfigureAllYourPersonalInformation',
        position: 'bottom',
      },
      GENERAL_FORM: {
        id: 'general-form',
        title: 'generalForm',
        text: 'hereYouCanViewOrEnterYourPersonalData',
        position: 'bottom',
      },
      COMMUNICATION: {
        id: 'communication',
        title: 'communicationSettings,',
        text: 'youCanToggleThisOptionsToEnableOrDisabledPromotionalMessages',
        position: 'bottom',
      },
      SAVE_BUTTON: {
        id: 'settings-header-save',
        title: 'save',
        text: 'yourPublicProfileWillBeCreatedBasedOnThem',
        position: 'bottom',
      },
    },
    CONNECTIONS: {
      WELCOME_MESSAGE: {
        id: 'connections-welcome',
        title: 'welcomeToTheConnectionsSection',
        text: 'hereYouConfigureAllYourConnections',
        position: 'bottom',
      },
      ADD_CONNECTION_BUTTON: {
        id: 'add-connection-button',
        title: '',
        text: 'letsStart',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => {
            clickOnButton('add-connection-button');
          },
        },
      },
      PROVIDER_SELECTION: {
        id: 'provider-selection',
        title: 'selectProvider',
        text: 'youMayAddAsManyConnections',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {
            closeModal('connections-modal', 'cancel-connection-button');
          },
          onNextFunction: () => {},
        },
      },
      API_KEY: {
        id: 'api-key-input',
        title: 'apiKey',
        text: 'theApiKeyAndSecretWillAllow',
        position: 'bottom',
      },
      API_PERMISSIONS: {
        id: 'api-key-input',
        title: 'apiPermissions',
        text: 'youCanAlsoAllowNickyToHandleSending',
        position: 'bottom',
      },
      PROVIDER_DOCS: {
        id: 'api-permissions',
        title: 'providerDocumentation',
        text: 'checkTheExchangeDocumentation',
        position: 'bottom',
      },
      PROVIDER_PERMISSIONS: {
        id: 'api-permissions',
        title: 'providerDocumentation',
        text: 'toSetupWithdrawals',
        position: 'bottom',
      },
      PROVIDER_DOCS_PERMISSIONS: {
        id: 'api-permissions',
        title: 'providerDocumentation',
        text: 'forUseAPI',
        position: 'bottom',
      },
      CONNECTION_NAME: {
        id: 'connection-name',
        title: 'connectionName',
        text: 'theNameIsCompletelyOptional',
        position: 'bottom',
      },
      FINISH_CONNECTION: {
        id: 'finish-connection',
        title: 'completeConnection',
        text: 'whenClickingOnAddConnection',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => {
            closeModal('connections-modal', 'cancel-connection-button');
          },
        },
      },
    },
    ROUTING: {
      WELCOME_MESSAGE: {
        id: 'routing-section',
        title: 'welcomeToTheRoutingSection',
        text: 'thisIsWhereYouConfigureTheRoutes',
        position: 'bottom',
      },
      WELCOME_MESSAGE_SECOND: {
        id: 'routing-section',
        //title: 'whatIsARoute',
        text: 'inNickyaRouteIsAConfiguration',
        position: 'bottom',
      },
      EDIT_ROUTES: {
        id: 'edit-routes-button',
        title: 'editRoutes',
        text: 'clickThisButtonToAddaNewWallet',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => {
            clickOnButton('edit-routes-button');
          },
        },
      },
      WALLET_PROVIDER: {
        id: 'wallet-provider-selection',
        title: 'selectWalletProvider',
        text: 'selectAWalletServiceProviderToSeeAllAssetsAvailableForIt',
        position: 'top',
        additionalButtonConfig: {
          onBackFunction: () => {
            closeModal('routing-modal', 'cancel-wallet-button-button');
          },
          onNextFunction: () => {},
        },
      },
      WALLET_SETUP: {
        id: 'wallet-provider-dropdown',
        title: 'walletSetup',
        text: 'eachAssetIsListedWithItsWalletProvider',
        position: 'bottom',
      },
      CANCEL_CHANGES: {
        id: 'cancel-wallet-button',
        title: 'cancelChanges',
        text: 'ifYouDoNotWalletToDoThisNow',
        position: 'bottom',
      },
      SAVE_CHANGES: {
        id: 'save-wallet-button',
        title: 'saveChanges',
        text: 'readyYourWalletHasBeenAdded',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => {
            closeModal('routing-modal', 'cancel-wallet-button-button');
          },
        },
      },
    },
    WALLET_MODAL_TOUR: {
      WALLET_PROVIDER: {
        id: 'wallet-provider-selection',
        title: 'selectWalletProvider',
        text: 'selectAWalletServiceProviderToSeeAllAssetsAvailableForIt',
        position: 'top',
      },
      WALLET_SETUP: {
        id: 'wallet-provider-dropdown',
        title: 'walletSetup',
        text: 'eachAssetIsListedWithItsWalletProvider',
        position: 'bottom',
      },
    },
    PAYMENT_CONVERSATIONS: {
      WELCOME_MESSAGE: {
        id: 'merchant-configuration',
        title: 'welcomeToThePaymentConversionsSection',
        text: 'paymentConversionsReferToTheProcess',
        position: 'bottom',
      },
      ASSETS_SELECTION: {
        id: 'payment-conversions-assets',
        title: 'assetsSelection',
        text: 'inThisSectionYouEnable',
        position: 'bottom',
      },
      CURRENCY_TOGGLE: {
        id: 'currency-toggle-BRL',
        title: 'currencyToggle',
        text: 'youCanChooseItAsAPaymentAsset',
        position: 'bottom',
      },
      CURRENCY_TOGGLE_TOGGLE: {
        id: 'currency-toggle-BRL-toggle',
        title: 'currencyToggle',
        text: 'byClickingTheOnOffButton',
        position: 'bottom',
      },
    },
    BANK_WITHDRAWAL: {
      BANK_WITHDRAWALS: {
        id: 'bank-withdrawals',
        title: 'whatIsAGlobalWithdrawal',
        text: 'nickyCanTakeCareOfYourCripto',
        position: 'bottom',
      },
      GLOBAL_WITHDRAWAL_THRESHOLD: {
        id: 'bank-withdrawals-global-withdrawal-threshold',
        title: 'globalWithdrawalThreshold',
        text: 'hereYouShouldSetupTheCriteria',
        position: 'bottom',
      },
      CURRENCY_ROW: {
        id: 'bank-withdrawals-global-withdrawal-threshold-currency',
        title: 'currency',
        text: 'thisIsTheTargetCurrency',
        position: 'bottom',
      },
      INPUT: {
        id: 'bank-withdrawals-global-withdrawal-threshold-input',
        title: 'input',
        text: 'thisIsTheMinimumValueForNicky',
        position: 'bottom',
      },
      ENABLED: {
        id: 'bank-withdrawals-global-withdrawal-threshold-enabled',
        title: 'enabled',
        text: 'ifDisabled',
        position: 'bottom',
      },
      BANK_ACCOUNT_CONFIGURATION: {
        id: 'bank-account-configuration',
        title: 'bankAccountConfiguration',
        text: 'thisIsWhereYouSetupYourBankAccounts',
        position: 'bottom',
      },
      ADD_CONFIGURATION_BUTTON: {
        id: 'add-configuration-button',
        title: 'addConfiguration',
        text: 'justClickTheButtonToAddANewWithdrawal',
        position: 'bottom',
      },
    },
    SECURITY: {
      CHANGE_PASSWORD_BUTTON: {
        id: 'change-password-button',
        title: 'changePassword',
        text: 'byClickingThisButtonYouChangePassword',
        position: 'bottom',
      },
      DELETE_ACCOUNT_BUTTON: {
        id: 'delete-account-button',
        title: 'deleteAccount',
        text: 'byClickingThisButtonYouPermanentlyDelete',
        position: 'bottom',
      },
    },
    MY_NICKS: {
      WELCOME_MESSAGE: {
        id: 'nicks',
        title: 'welcomeToYourNicks',
        text: 'hereYouCanViewAndManageYourNicks',
        position: 'bottom',
      },
      WHAT_IS_NICK: {
        id: 'info',
        title: 'whatIsANick',
        text: 'aNickWorksLike',
        position: 'bottom',
      },
      TYPES_OF_NICKS: {
        id: 'info',
        title: 'aboutNicks',
        text: 'typesOfNicks',
        position: 'bottom',
      },
      HOW_DO_NICKS_WORKS: {
        id: 'info',
        title: 'howDoNicksWork',
        text: 'exampleOfNickUsage',
        position: 'bottom',
      },
      MORE_THAN_ONE: {
        id: 'info',
        title: 'canIHaveMoreThanOneNick',
        text: 'multipleNicksExplanation',
        position: 'bottom',
      },
      SOMEBODY_ELSE_USE: {
        id: 'info',
        title: 'canSomeoneElseUseMyNick',
        text: 'nickOwnership',
        position: 'bottom',
      },
      SHORT_ID_NICK: {
        id: 'short-id',
        title: 'shortIdNick',
        text: 'shortIdNickExplanation',
        position: 'bottom',
      },
      EMAIL_NICK: {
        id: 'email',
        title: 'emailNick',
        text: 'emailNickExplanation',
        position: 'bottom',
      },
      EMAIL_NICK_WORKS: {
        id: 'email',
        title: 'howEmailNicksWork',
        text: 'forExampleEmailNick',
        position: 'bottom',
      },
      DOMAIN_NICK: {
        id: 'domain',
        title: 'domainNick',
        text: 'domainNickExplanation',
        position: 'bottom',
      },
      FINAL_MESSAGE: {
        id: 'finish',
        title: 'nextSteps',
        text: 'nowThatYouKnowHowNicksWork',
        position: 'bottom',
      },
    },
    API_MANAGEMENT: {
      WELCOME_MESSAGE: {
        id: 'info',
        title: 'introductionToApiSettings',
        text: 'welcomeToTheApiSettingsTour',
        position: 'bottom',
      },
      PURPOSE_API: {
        id: 'info',
        title: 'whatsThePurposeOfAnApiKey',
        text: 'apiKeyPurposeDescription',
        position: 'bottom',
      },
      GENERATE_BUTTON: {
        id: 'generate-new-api-key-button',
        title: 'generatingApiKeys',
        text: 'generatingApiKeysDescription',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => {
            clickOnButton('generate-new-api-key-button');
          },
        },
      },
      CONFIGURING_API: {
        id: 'provider-selection',
        title: 'configuringApiKeyPermissions',
        text: 'configuringApiKeyPermissionsDescription',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {
            closeModal('api-settings-modal', 'cancel-button-button');
          },
          onNextFunction: () => {},
        },
      },
      API_PERMISSIONS: {
        id: 'permissions-api',
        title: 'understandingApiPermissions',
        text: 'understandingApiPermissionsDescription',
        position: 'bottom',
      },
      MORE_DETAILS: {
        id: 'link-swagger',
        title: 'needMoreDetails',
        text: 'needMoreDetailsDescription',
        position: 'bottom',
      },
      GENERATING_KEYS: {
        id: 'finish-connection',
        title: 'readyToGenerateApiKey',
        text: 'readyToGenerateApiKeyDescription',
        position: 'bottom',
      },
      GENERATED_KEYS: {
        id: 'finish-connection',
        title: 'apiKeyIsReady',
        text: 'apiKeyIsReadyDescription',
        position: 'bottom',
      },
      FINAL_MESSAGE: {
        id: 'finish',
        title: 'endingApiTour',
        text: 'endingApiTourDescription',
        position: 'bottom',
        additionalButtonConfig: {
          onBackFunction: () => {},
          onNextFunction: () => {
            closeModal('routing-modal', 'cancel-wallet-button-button');
          },
        },
      },
    },
  },
} as const;

const closeModal = (modalId: string, cancelButtonId: string) => {
  const modal = document.querySelector(`#${modalId}`);
  if (modal) {
    const cancelButton = document.querySelector(`#${cancelButtonId}`);
    (cancelButton as HTMLElement).click();
  }
};

const reopenModal = (openButtonId: string) => {
  clickOnButton(openButtonId);
};

const clickOnButton = (buttonId: string) => {
  const element = document.querySelector(`#${buttonId}`);
  if (element) {
    (element as HTMLElement).click();
  }
};

const navigateToSection = (sectionId: string, tabId: string) => {
  if (isMobile()) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  } else {
    clickOnButton(tabId);
  }
};
